import { render, staticRenderFns } from "./FixKeyboard.vue?vue&type=template&id=74e945dc&scoped=true"
import script from "./FixKeyboard.vue?vue&type=script&lang=js"
export * from "./FixKeyboard.vue?vue&type=script&lang=js"
import style0 from "./FixKeyboard.vue?vue&type=style&index=0&id=74e945dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e945dc",
  null
  
)

export default component.exports